import React, { useState } from "react";
import { Link } from 'react-router-dom';
import logo from "../assets/logo.svg"
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaYoutube, FaGlobe, FaEnvelope } from "react-icons/fa";
import { db } from "../firebase_config";
import { collection, addDoc } from "firebase/firestore";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Footer = () => {
  const [emailAddress, setEmailAddress] = useState("");
  const [buttonLoading, setButtonLoading] = useState(false);

  const postDataToFirestore = async () => {
    try {
      setButtonLoading(true)
      const data = {
        email: emailAddress,
        timestamp: new Date(), // Optional: Add a timestamp
      };

      // Reference the "users" collection in Firestore
      await addDoc(collection(db, "waiting"), data);
      setEmailAddress("");
      setButtonLoading(false)
      toast.success('Thank you for subscribing!, ConRa will be in touch as soon as possible', {
        position: "top-right",
        autoClose: 3000, // Auto close after 3 seconds
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light", // Use "dark" for a dark theme
        className: "custom-toast"
      });
    } catch (error) {
      setButtonLoading(false)
      console.error("Error adding document: ", error);
    }
  };

  const handleClick = (message) => {
    postDataToFirestore()
  };
  return (
    <footer>
      <ToastContainer />
      <div className="footer-container">
        <div className="footer-section">
          {/* <h2 className="brand"> <img src={logo} /> ConRa</h2> */}
          <div className="brand">
            <img src={logo} alt="ConRa Logo" className="brand-logo" />
            <h2>ConRa</h2>
          </div>
          <p className="subscribe-text">
            Be the first to know about new features, updates, and helpful resources.
          </p>
          <div className="subscribe-form">
            <div className="input-with-icon">
              <FaEnvelope className="email-icon" />
              <input type="email" placeholder="Enter your email" />
            </div>
            <button type='button'
              disabled={buttonLoading}
              onClick={(e) => {
                e.preventDefault();
                handleClick("Hello from the button!");
              }}>
              {buttonLoading ? (
                "Sending ... "
              ) : (
                "Subscribe"
              )}
            </button>
          </div>
        </div>
        <div className="footer-links">
          <div>
            <h3>Platform</h3>
            <ul>
              <li><Link to="/platform/features">Features</Link></li>
              <li><Link to="/pricing">Pricing</Link></li>
              <li><Link to="/faq">FAQs</Link></li>
            </ul>
          </div>
          <div>
            <h3>Company</h3>
            <ul>
              <li><Link to="/contact-us">Contact Us</Link></li>
              <li><a href="/about" >About Us</a></li>
              <li><a href="/careers" >Careers</a></li>
              <li><a href="#" >Team</a></li>
              {/* <li><a href="/contact-us" >Contact Us</a></li> */}
            </ul>
          </div>
          <div>
            <h3>Resources</h3>
            <ul>
              <li><a href="https://play.google.com/store/apps/details?id=com.conra_mobile.app" target="/blank" >Android App</a></li>
              <li><a href="https://apps.apple.com/us/app/conra-smart-construction/id6762303075">iOS App</a></li>
              <li><a href="/blog" target="/blog" >Blog</a></li>
            </ul>
          </div>
          <div>
            <h3>Legal</h3>
            <ul>
              <li><a href="/terms-of-service" target="_blank">Terms of Service</a></li>
              <li><a href="/acceptable-use" target="_blank">Acceptable Use</a></li>
              <li><a href="/privacy-policy" target="_blank">Privacy Policy</a></li>
              <li><a href="/cookie-policy" target="_blank">Cookie Policy</a></li>
              <li><a href="/refund-policy" target="_blank">Refund Policy</a></li>
              <li><a href="/docs/odpc-registration-certificate.pdf" target="_blank" rel="noopener noreferrer">ODPC Certificate</a></li>
            </ul>
          </div>
        </div>
      </div>
      <div className="footer-container footer-bottom">
        <p>&copy; 2025 All Rights Reserved</p>
        <div className="footer-socials">
          <span><FaGlobe /> English (US)</span>
          {/* <span>🔵📘</span> <span>🔗</span> <span>🐦</span> <span>▶️</span> */}
          <span><a href="https://www.facebook.com/" target="_blank" className="social-icon"><FaFacebookF /></a></span>
          <span><a href="https://www.linkedin.com/" target="_blank" className="social-icon"><FaLinkedinIn /></a></span>
          <span><a href="https://x.com/" target="_blank" className="social-icon"><FaTwitter /></a></span>
          <span><a href="https://www.youtube.com/" target="_blank" className="social-icon"><FaYoutube /></a></span>
        </div>
        <div className="foot-buttons">
          <a href="https://apps.apple.com/us/app/conra-smart-construction/id6762303075" target="_blank" rel="noopener noreferrer">
            <img src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
              alt="Download on the App Store"
              className="store-button" />
          </a>
          <a href="https://play.google.com/store/apps/details?id=com.conra_mobile.app" target="_blank" rel="noopener noreferrer">
            <img src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
              alt="Get it on Google Play"
              className="store-button" />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
